<template>
  <div class="spinning-wheel">
    <img class="image" src="~images/spinningwheel.gif" />
  </div>
</template>

<script>
  export default {
    name: 'SpinningWheel'
  }
</script>

<style lang="scss" scoped>
  .spinning-wheel {
    text-align: center;
  }

  .image {
    display: table;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/js/components/SpinningWheel.vue